// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Button from 'components/Button';
import Icon from 'components/Icon';
import { colors, transition, fontWeights } from 'theme';

const CloseButton = styled(Button)`
  color: ${colors.battleshipGrey};
  transition: all ${transition};
  &:hover {
    color: ${colors.waterBlue};
  }
`;

type Status = 'NEW';

const getStatus: Status => {
  theme: { bg: string, color: string },
  label: string
} = status => {
  switch (status) {
    case 'NEW':
    default:
      return {
        theme: {
          color: 'white',
          bg: colors.waterBlue
        },
        label: getText('New')
      };
  }
};

export const StatusTag = (props: Object) => (
  <Box
    data-qa-id="listing-status"
    display="inline-block"
    py="3px"
    px="5px"
    borderRadius="4px"
    letterSpacing="1px"
    textTransform="uppercase"
    lineHeight={1}
    fontWeight={fontWeights.semiBold}
    fontSize={11}
    {...props}
  />
);

export const StatusLabel = ({ status }: { status: Status }) => {
  const { theme, label } = getStatus(status);
  return (
    <StatusTag mb={12} {...theme}>
      {label}
    </StatusTag>
  );
};

const UserNotification = ({
  status,
  children,
  dismiss,
  ...props
}: {
  status?: Status,
  children: React.Node,
  dismiss?: Function
}) => (
  <Box position="relative" {...props}>
    {status && <StatusLabel status={status} />}

    <Box lineHeight={1.375}>{children}</Box>

    {dismiss && (
      <Box position="absolute" top={0} right={0}>
        <CloseButton onClick={dismiss}>
          <Icon name="close" width={12} height={12} fill="currentColor" />
        </CloseButton>
      </Box>
    )}
  </Box>
);

export default UserNotification;
